var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29,25l-9.2,9.2L11,25.3c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l9.2,9.1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l9.5-9.5c0.2-0.2,0.2-0.5,0-0.7S29.2,24.8,29,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.6,7.9c0,0-0.9,0.9-1.6,2.4c-0.4-0.9-1-1.7-1.7-2.4c-3.6-3.6-9.4-3.6-13,0c-1.7,1.7-2.7,4-2.7,6.5s1,4.7,2.7,6.5C5.5,21,5.8,21,6,20.8c0.2-0.2,0.2-0.5,0-0.7c-1.6-1.5-2.4-3.6-2.4-5.8c0-2.2,0.9-4.3,2.4-5.8c3.2-3.2,8.5-3.2,11.7,0c0.9,0.9,1.5,1.8,1.9,3c0.1,0.2,0.2,0.2,0.4,0.2c0,0,0,0,0,0c0.2,0,0.4,0,0.4-0.2c0.6-1.9,1.8-3,1.8-3.1c3.2-3.2,8.5-3.2,11.7,0c1.6,1.5,2.4,3.6,2.4,5.8c0,2.2-0.9,4.3-2.4,5.8c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c1.7-1.7,2.7-4,2.7-6.5s-1-4.7-2.7-6.5C31.1,4.3,25.2,4.3,21.6,7.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.9,22.1H25.6c-0.2,0-0.3,0.1-0.4,0.2l-1.9,3l-2.4-8.2c-0.1-0.2-0.2-0.3-0.4-0.3c-0.2,0-0.4,0.1-0.5,0.3L17,23.6l-1.8-3.7c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2,0-0.3,0-0.4,0.2l-2.1,2.3H4.1c-0.3,0-0.5,0.2-0.5,0.5S3.8,23,4.1,23h8.5c0.1,0,0.3-0.1,0.3-0.2l1.8-2l1.9,3.9c0.1,0.2,0.2,0.2,0.4,0.2c0,0,0,0,0,0c0.2,0,0.3,0,0.4-0.2l3-6.2l2.3,8c0.1,0.2,0.2,0.3,0.4,0.3c0,0,0,0,0.1,0c0.2,0,0.3-0.1,0.4-0.2l2.3-3.7h10.1c0.3,0,0.5-0.2,0.5-0.5S36.2,22.1,35.9,22.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/HeartRate.9c7c36eb74cb87f8498d3fd340c1b0a2.svg";
export { ForwardRef as ReactComponent };